import React from 'react'

export default function Aboutus() {
  return (
    <section className="text-gray-600 body-font">
    <div className="container px-5 py-24 mx-auto">
      <div className="xl:w-1/2 lg:w-3/4 w-full mx-auto text-center">
       <h1 style={{ fontFamily: 'Instagram Sans Headline' }} className=' text-slate-200 font-extrabold '>About Us</h1>
        <p className="leading-relaxed text-lg text-slate-200 " style={{ fontFamily: 'Instagram Sans Medium' }}>YoursBuddy uses expert video editing to turn your content into visually appealing videos. We have the knowledge and resources necessary to produce any type of video, including tutorials, testimonials, and advertising campaigns. Any video format, style, or genre is something we can manage. To strengthen your message and brand, we can also add effects, transitions, music, subtitles, and other things. We can provide high-quality videos that will wow your audience and help you reach your objectives, regardless of your budget or timeframe. Reach out to us right away, and let's work some magic.</p>
        <span className="inline-block h-1 w-10 rounded bg-indigo-500 mt-8 mb-6"></span>
      
      </div>
    </div>
  </section>
  )
}
